import React from 'react';
import DocsList from 'features/docs/components/DocsList';
import { Tabs, Tab } from 'shared/ui/Tabs';
import SnapsList from 'features/stats/components/snaps/SnapsList';
import { formatDate } from 'shared/utils/format';

const formatPrice = (price) => Math.round(price || 0).toLocaleString('ru-RU');

const ProductItem = ({ item }) => {
  const salePrice = item.discount > 0 
    ? item.price * (1 - item.discount / 100) 
    : item.price;

  return (
    <>
      {/* Header Section */}
      <div className='mb-6'>
        <div className='flex justify-between items-start'>
          <h1 className='text-2xl font-normal mb-1'>{item.name}</h1>
          <span className='text-gray-400'>Товар</span>
        </div>
        <div className='text-sm mb-2'>
          Создан {formatDate(item.created)}
        </div>
        <div className='flex gap-2 flex-wrap'>
          {item.discount > 0 ? (
            <span className='bg-green-500 text-white text-sm px-2 py-1 rounded'>
              Цена: <span className='line-through opacity-70'>{formatPrice(item.price)}</span> → {formatPrice(salePrice)} сом
            </span>
          ) : (
            <span className='bg-green-500 text-white text-sm px-2 py-1 rounded'>
              Цена: {formatPrice(item.price)} сом
            </span>
          )}
          <span className='bg-orange-500 text-white text-sm px-2 py-1 rounded'>
            Себестоимость: {formatPrice(item.cost)} сом
          </span>
          {item.discount > 0 && (
            <span className='bg-red-500 text-white text-sm px-2 py-1 rounded'>
              Скидка: {Math.round(item.discount)}%
            </span>
          )}
        </div>
      </div>

      {/* Product Info Section */}
      <div className='mb-6'>
        <h2 className='text-lg font-medium mb-2'>ИНФОРМАЦИЯ</h2>
        <div className='space-y-2'>
          <div className='flex justify-between border-b border-dotted pb-1'>
            <span>Штрихкод</span>
            <span className='text-blue-600'>{item.barcode}</span>
          </div>
          <div className='flex justify-between border-b border-dotted pb-1'>
            <span>Артикул</span>
            <span>{item.code}</span>
          </div>
          {item.category && (
            <div className='flex justify-between border-b border-dotted pb-1'>
              <span>Категория</span>
              <span>{item.category.name}</span>
            </div>
          )}
          {item.supplier?.meta && (
            <div className='flex justify-between border-b border-dotted pb-1'>
              <span>Поставщик</span>
              <span>{item.supplier.meta.name}</span>
            </div>
          )}
        </div>
      </div>

      {/* Pricing Section */}
      <div className='mb-6'>
        <h2 className='text-lg font-medium mb-4'>ЦЕНЫ</h2>
        <div className='grid gap-4 grid-cols-2'>
          <div className='space-y-2'>
            <div className='flex justify-between border-b border-dotted pb-1'>
              <span>Цена продажи</span>
              <span className='text-green-600'>{formatPrice(item.price)} сом</span>
            </div>
            {item.discount > 0 && (
              <div className='flex justify-between border-b border-dotted pb-1'>
                <span>Цена со скидкой</span>
                <span className='text-red-600'>{formatPrice(salePrice)} сом</span>
              </div>
            )}
            <div className='flex justify-between border-b border-dotted pb-1'>
              <span>Себестоимость</span>
              <span>{formatPrice(item.cost)} сом</span>
            </div>
            <div className='flex justify-between border-b border-dotted pb-1'>
              <span>Закупочная цена</span>
              <span>{formatPrice(item.purchase)} сом</span>
            </div>
            <div className='flex justify-between border-b border-dotted pb-1'>
              <span>Скидка</span>
              <span>{Math.round(item.discount || 0)}%</span>
            </div>
          </div>
        </div>
      </div>

      {/* Tabs Section */}
      <div>
        <Tabs initialTab='docs'>
          <Tab key='docs' label='Документы'>
            <DocsList product={item.meta} />
          </Tab>
          <Tab key='snaps' label='Снимки'>
            <SnapsList product={item.meta} />
          </Tab>
          <Tab key='stock' label='Остатки'>
            <div className='text-center text-gray-500 font-medium py-4'>
              Функционал остатков будет добавлен позже
            </div>
          </Tab>
          <Tab key='stats' label='Статистика'>
            <div className='text-center text-gray-500 font-medium py-4'>
              Функционал статистики будет добавлен позже
            </div>
          </Tab>
        </Tabs>
      </div>
    </>
  );
};

export default ProductItem;